import { MDXEditor, type MDXEditorMethods } from '@mdxeditor/editor';
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  Paper,
  Stack,
  Switch
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { useRef, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import Markdown from 'react-markdown';

import { MARKDOWN_REMARK_PLUGINS } from '@/constants/markdown.constants';

import {
  ANNOUNCEMENT_MDX_EDITOR_CONFIG,
  AnnouncementDialogType
} from './AnnouncementDialog.constants';

const AnnouncementDialogMarkdown = ({ type }: { type: string }) => {
  const { mode: themeMode } = useColorScheme();
  const ref = useRef<MDXEditorMethods>(null);
  const { control, setValue, trigger } = useFormContext();
  const body = useWatch({ control, name: 'body' });
  const [showPreview, setShowPreview] = useState(false);

  const handleBodyChange = () => {
    const markdown = ref.current?.getMarkdown();
    setValue('body', markdown?.replaceAll('&#x20;', '') || '');
    trigger('body');
  };

  return (
    <div className={themeMode}>
      <Stack
        direction="row"
        sx={{ alignItems: 'center', justifyContent: 'space-between' }}
      >
        <InputLabel>
          Message {type !== AnnouncementDialogType.VIEW && '*'}
        </InputLabel>
        {type !== AnnouncementDialogType.VIEW && (
          <FormControlLabel
            control={
              <Switch
                checked={showPreview}
                onChange={() => setShowPreview(!showPreview)}
              />
            }
            label="Preview"
          />
        )}
      </Stack>
      {type !== AnnouncementDialogType.VIEW && !showPreview && (
        <Controller
          control={control}
          name="body"
          rules={{
            required: true
          }}
          render={({ field, formState }) => (
            <FormControl fullWidth>
              <MDXEditor
                className={formState.errors.body ? 'has-error' : ''}
                ref={ref}
                contentEditableClassName="cm-richView"
                markdown={field.value}
                plugins={ANNOUNCEMENT_MDX_EDITOR_CONFIG}
                suppressHtmlProcessing
                onBlur={handleBodyChange}
              />
            </FormControl>
          )}
        />
      )}
      {(showPreview || type === AnnouncementDialogType.VIEW) && (
        <Paper sx={{ p: 2, minHeight: '3rem' }} variant="outlined">
          <div className="markdown-body">
            <Markdown
              disallowedElements={['img']}
              remarkPlugins={MARKDOWN_REMARK_PLUGINS}
              unwrapDisallowed
            >
              {body}
            </Markdown>
          </div>
        </Paper>
      )}
    </div>
  );
};

export default AnnouncementDialogMarkdown;
